
<a class="telLink" :href="'tel:' + value">
  <template v-if="$slots.default">
    <slot></slot>
  </template>
  <template v-else>
    {{ value }}
  </template>
</a>
